var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSquareFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44.001,
    viewBox: "0 0 44 44.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-square-full",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_226",
    d: "M36.4-1H5.6A6.6,6.6,0,0,0-1,5.6V40.8l.013.251a2.2,2.2,0,0,0,3.74,1.307L10.911,34.2H36.4A6.6,6.6,0,0,0,43,27.6V5.6A6.6,6.6,0,0,0,36.4-1Z",
    transform: "translate(0 0)",
    fill: "#4a4a4a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSquareFull);
export default __webpack_public_path__ + "static/media/message-square-full.c81c117abd902fb838b5841e07946665.svg";
export { ForwardRef as ReactComponent };